import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { extractDate } from "../../../Components/Functions/date.fun";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
import { useState } from "react";
import { useEffect } from "react";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { titleCaseChange } from "../../../Components/Functions/changeFirstLetterUpperCase";
import { BsFillPatchExclamationFill } from "react-icons/bs";

const tableHead = [
  "Sr.",
  "Date / Invoice / Pi Num",
  "Payment For / Vendor Name",
  "Amount / Payment Type",
  "Status",
  "Issues",
  "Actions",
  "Delete",
];
const returnClassname = (item) => {
  if (item?.status) return "badge bg-success text-white";
  if (item?.paymentRejectStatus) return "badge bg-danger text-white";
  return "badge bg-orange text-white";
};

const returnClassnameType = (type) => {
  if (type === "Advanced Payment") {
    return "badge bg-yellow text-yellow-fg";
  } else if (type === "Remaining Payment") {
    return "badge bg-purple text-purple-fg";
  } else {
    return "badge bg-lime text-lime-fg";
  }
};
const ReqForPaymentTable = ({
  requests = [],
  currentPage,
  itemsPerPage,
  onRefresh = () => {},
}) => {
  const user = useSelector((store) => store.login.user);
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/req-for-payment/view/${id}`);
  };
  const [vendors, setVendors] = useState([]);
  const [issueMessage, setIssueMessage] = useState("");
  const [showIssuePopup, setShowIssuePopup] = useState(false);

  useEffect(() => {
    fetchVendors();
  }, []);

  const fetchVendors = async () => {
    try {
      const res = await performRequest("GET", "/poDcPi/getAllVendorList");
      if (res.status === 200) {
        setVendors(res?.data); // assuming API returns array of vendors
      } else {
        Toast("error", "Error fetching vendors!");
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getVendorName = (vendorId) => {
    const vendor = vendors.find((v) => String(v?.id) === String(vendorId));
    return vendor ? vendor?.businessName : vendor?.contactPersonName; // fallback to ID if not found
  };

  const getStatusText = (item) => {
    if (item?.status) return "Approved";
    if (item?.paymentRejectStatus) return "Reject Payment";
    return "Pending";
  };

  const isDeleteDisabled = (item) => {
    return item?.status === true || item?.paymentRejectStatus === true;
  };

  const changeStatus = (id) => {
    performRequest("PATCH", `/request/updateStatus/${id}`, {
      removePayment: true,
      removePaymentById: user?.UserId,
    })
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Payment delete successfully!");
          // setRefresh(!refresh);
          onRefresh();
        } else {
          Toast("error", "Error while deleting payment");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {requests?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <>
                <tr key={item?.id}>
                  <td>{Index}</td>
                  {/* <td>{getId(item?.dcNumber)}</td> */}
                  <td>
                    {extractDate(item?.createdAt) || "N/A"}
                    <br />

                    <b>{item?.invoicenumber || item?.invoicenumber}</b>
                  </td>
                  <td>
                    {item?.paymentfor || "N/A"}
                    <br />
                    <a
                      href={`/purchase-vendor-management/view-vendor/${item?.vendor}`}
                    >
                      {titleCaseChange(getVendorName(item?.vendor))}
                    </a>
                  </td>
                  <td>
                    <span className="fs-2" style={{ fontWeight: "600" }}>
                      ₹
                      {item?.amount
                        ? Number(item.amount).toLocaleString("en-IN")
                        : "N/A"}
                    </span>
                    <br />
                    <span className="mt-1">
                      <span className={returnClassnameType(item?.paymentType)}>
                        {item?.paymentType || "N/A"}
                      </span>
                    </span>
                  </td>
                  <td>
                    <span className={returnClassname(item)}>
                      {getStatusText(item)}
                    </span>
                  </td>
                  <td>
                    {item?.isIssued === true ? (
                      <button
                        type="button"
                        className="btn btn-sm btn-danger rounded-circle"
                        data-bs-toggle="modal"
                        data-bs-target={`#issue-modal-${item.id}`}
                        onClick={() => {
                          setIssueMessage(
                            item?.aiMessage || "No issue message available."
                          );
                        }}
                      >
                        <BsFillPatchExclamationFill size={18} />
                      </button>
                    ) : (
                      <span className="text-success" size={18}>✅</span>
                    )}
                  </td>
                  <td>
                    <CustomViewButton
                      onClick={() => goToView(item.id)}
                    ></CustomViewButton>
                  </td>
                  <td>
                    {user.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                    user.Role === process.env.REACT_APP_ROLE_ADMIN ? (
                      <button
                        disabled={isDeleteDisabled(item)}
                        className="btn btn-sm px-3 btn-danger"
                        onClick={() => changeStatus(item.id)}
                      >
                        Delete
                      </button>
                    ) : item?.generatedById == user?.UserId ? (
                      <button
                        disabled={isDeleteDisabled(item)}
                        className="btn btn-sm px-3 btn-danger"
                        onClick={() => changeStatus(item.id)}
                      >
                        Delete
                      </button>
                    ) : (
                      "N/A"
                    )}
                  </td>
                </tr>
                <div
                  className="modal modal-blur fade"
                  id={`issue-modal-${item.id}`}
                  tabIndex="-1"
                  role="dialog"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">
                          <BsFillPatchExclamationFill
                            className="text-danger me-2"
                            size={18}
                          />
                          Payment Issue
                        </h5>

                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                        ></button>
                      </div>

                      <div className="modal-body">
                        <div
                          style={{
                            whiteSpace: "pre-line",
                            maxHeight: "400px",
                            overflowY: "auto",
                          }}
                        >
                          {issueMessage || "No issue message available."}
                        </div>
                      </div>

                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ReqForPaymentTable;
